<template>
  <section class="bg-black">
    <div class="featured-wrapper flex sm:flex-col">
      <div class="featured-text w-1/3 sm:w-full pl-20 sm:pl-0 pt-20 block xlh:block smh:hidden">
        <p class="featureddish" data-aos="fade-left" data-aos-offset="2500">FEATURED DISH</p>
        <p class="whatoffer sm:text-center" data-aos="fade-right" data-aos-offset="2500">
          WHAT <br />
          WE OFFER
        </p>
        <router-link to="Menu" 
        class="seemenu sm:px-8 mt-32 block sm:mt-8" 
        data-aos="fade-right"
        data-aos-offset="2500"
        @click="toggle">SEE MENU</router-link>
        <div class="w-2/4 float-right pr-8" style="margin-top: -20px">
          <hr />
        </div>
      </div>

      <div class="featured-text w-1/3 sm:w-full pl-20 sm:pl-0 pt-20 hidden xlh:hidden smh:block">
        <p class="featureddish" data-aos="fade-left" data-aos-offset="0">FEATURED DISH</p>
        <p class="whatoffer sm:text-center" data-aos="fade-right" data-aos-offset="0">
          WHAT <br />
          WE OFFER
        </p>
        <router-link to="Menu" 
        class="seemenu sm:px-8 mt-32 block sm:mt-8" 
        data-aos="fade-right"
        data-aos-offset="0"
        @click="toggle">SEE MENU</router-link>
        <div class="w-2/4 float-right pr-8" style="margin-top: -20px">
          <hr />
        </div>
      </div>

      <div class="featured-carousel w-2/3 cursor-pointer sm:w-full sm:hidden">
        <swiper
          :slides-per-view="3"
          :direction="horizontal"
          :space-between="20"
          :mousewheel="{ releaseOnEdges: true }"
        >
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-7.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-8.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-9.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-10.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-11.jpg')" alt="" />
          </swiper-slide>
        </swiper>
      </div>

      <div class="featured-carousel hidden w-2/3 sm:mt-8 sm:w-full sm:block">
        <swiper
          :slides-per-view="1.5"
          :direction="horizontal"
          :space-between="20"
          :mousewheel="{ releaseOnEdges: true }"
        >
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-7.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-8.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-9.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-10.jpg')" alt="" />
          </swiper-slide>
          <swiper-slide
            ><img :src="require('../assets/home/HOME-dish-11.jpg')" alt="" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import SwiperCore, { Mousewheel } from "swiper";
import "swiper/swiper.scss";
import { Swiper, SwiperSlide } from "swiper/vue";

SwiperCore.use({ Mousewheel });
export default {
  data() {
    return {};
  },
  components: {
    Swiper,
    SwiperSlide
  }
};
</script>

<style scoped>
.seemenu {
  padding-right: 20px;
  position: relative;
  padding-top: 5px;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 36px;
  /* identical to box height, or 150% */

  letter-spacing: 0.05em;
  text-decoration-line: underline;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
.featureddish {
  font-family: avenirLight;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
  letter-spacing: 0.15em;
  text-transform: uppercase;

  color: #c7272b;
}
.whatoffer {
  padding-top: 2rem;
  font-family: Times;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 2.3rem;
  /* or 109% */

  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
</style>